import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const COOKIE_NAME = 'tokens';

const getCookieOptions = () => {
  const options = {
    expires: 365 * 100,
    secure: process.env.REACT_APP_COOKIE_SECURE === 'true',
    sameSite: process.env.REACT_APP_COOKIE_SAMESITE || 'strict',
  };
  // برای توسعه روی localhost دامنه را ست نکن تا کوکی هم‌دامنه باشد و خوانده شود
  const isDev = typeof window !== 'undefined' && window.location?.hostname === 'localhost';
  if (!isDev && process.env.REACT_APP_COOKIE_DOMAIN) {
    options.domain = process.env.REACT_APP_COOKIE_DOMAIN;
  }
  return options;
};

const normalizeToken = (obj) => {
  if (!obj) return null;
  const src = obj?.data?.accessToken ? obj.data : obj;
  if (!src?.accessToken) return null;
  let userName = src.userName;
  try {
    const decoded = jwtDecode(src.accessToken);
    userName = userName || decoded?.userName || decoded?.email || decoded?.Email || null;
  } catch {}
  return {
    accessToken: src.accessToken,
    refreshToken: src.refreshToken,
    userName,
    // keep original payload for compatibility
    raw: src,
  };
};

export const getTokens = () => {
  try {
    const t = JSON.parse(Cookies.get(COOKIE_NAME));
    return t || { main: null, profile: null };
  } catch {}
  // Fallback: try legacy single cookie 'token' (assume main)
  try {
    const single = JSON.parse(Cookies.get('token'));
    const norm = normalizeToken(single);
    return { main: norm, profile: null };
  } catch {}
  // Fallback: localStorage tokenLogin (assume main)
  try {
    const ls = JSON.parse(localStorage.getItem('tokenLogin'));
    const norm = normalizeToken(ls);
    return { main: norm, profile: null };
  } catch {}
  return { main: null, profile: null };
};

export const setTokens = (tokens) => {
  Cookies.set(COOKIE_NAME, JSON.stringify(tokens), getCookieOptions());
};

export const setTokenFor = (system, tokenObj) => {
  const tokens = getTokens();
  tokens[system] = normalizeToken(tokenObj);
  setTokens(tokens);
  // Keep legacy cookie 'token' for existing profile flows
  if (system === 'profile' && tokens.profile?.raw) {
    // Write legacy cookie in the shape Header expects: { data: { accessToken, refreshToken, ... } }
    Cookies.set(
      'token',
      JSON.stringify({ data: tokens.profile.raw }),
      getCookieOptions()
    );
  }

  // Maintain legacy localStorage token for main flows to support older reads
  if (system === 'main' && tokens.main) {
    const compatMain = {
      accessToken: tokens.main.accessToken,
      refreshToken: tokens.main.refreshToken,
      userName: tokens.main.userName,
      data: {
        accessToken: tokens.main.accessToken,
        refreshToken: tokens.main.refreshToken,
        userName: tokens.main.userName,
      },
    };
    try {
      localStorage.setItem('tokenLogin', JSON.stringify(compatMain));
    } catch {}
  }
};

export const getAccessToken = (system) => {
  const tokens = getTokens();
  return tokens?.[system]?.accessToken || null;
};

export const getRefreshToken = (system) => {
  const tokens = getTokens();
  return tokens?.[system]?.refreshToken || null;
};

export const getUserName = (system) => {
  const tokens = getTokens();
  return tokens?.[system]?.userName || null;
};

export default {
  getTokens,
  setTokens,
  setTokenFor,
  getAccessToken,
  getRefreshToken,
  getUserName,
};